<template>
  <div class="payouts-by-registry-page">
    <transactions-page-controls
      :has-filter="false"
      :has-export="false"
      :has-total-stats="false"
      :has-stats="false"
      @refresh="loadPayoutsRegistries"
    >
      <template #plainFilter>
        <div class="payouts-by-registry__date-filter">
          <custom-date-picker
            :config="{ floatingTitle: true, transparent: true }"
            v-model:value="filter.dateFrom"
          ></custom-date-picker>
          <custom-date-picker
            :config="{ floatingTitle: true, transparent: true }"
            v-model:value="filter.dateTo"
          ></custom-date-picker>
        </div>
      </template>
      <template #specificActions>
        <require-access action="read" data="payout-to-card-make_payout">
          <primary-button
            class="payouts-by-registry__upload-btn"
            :label="$t('payouts.by-registry.actions.upload')"
            @click="uploadPayoutsRegistry"
          ></primary-button>
        </require-access>
      </template>
    </transactions-page-controls>
    <payouts-registries-table
      :payouts-registries-list="payoutsRegistries"
      v-if="!isDataLoading"
      @registryDeleted="handleRegistryDeleted"
    ></payouts-registries-table>
    <loader v-else></loader>
    <success-notification
      ref="registryDeletedNotification"
      :text="$t('payouts.by-registry.notifications.registry-deleted')"
    ></success-notification>
  </div>
</template>

<script>
import responsiveMixin from '@vue-app/mixins/responsive-mixin'

import { mapGetters, mapState } from 'vuex'
import PayoutsToCardTable from '@vue-app/components/company/payouts/to-card/table/PayoutsToCardTable.vue'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'
import TransactionsPageControls from '@vue-app/components/company/transactions/shared/transactions-page-controls/TransactionsPageControls.vue'
import { Stats } from '@js-app/entities/transaction/Stats'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import PayoutsRegistriesTable from '@vue-app/components/company/payouts/by-registry/table/PayoutsRegistriesTable.vue'
import CustomDatePicker from '@vue-app/components/base/input/CustomDatePicker.vue'
import Loader from '@vue-app/components/base/Loader.vue'
import SuccessNotification from '@vue-app/components/base/popup/notification/SuccessNotification.vue'

export default {
  name: 'PayoutsRegistries',
  components: {
    SuccessNotification,
    Loader,
    CustomDatePicker,
    PayoutsRegistriesTable,
    PrimaryButton,
    TransactionsPageControls,
    RequireAccess,
    PayoutsToCardTable,
  },
  props: {
    id: {
      type: [String, Number],
    },
  },
  mixins: [responsiveMixin],
  data() {
    return {
      isDataLoading: false,
      payoutsToCardStats: new Stats(),
      payoutsRegistries: [],
      filter: {
        dateFrom: this.$moment().subtract('1', 'month').toDate(),
        dateTo: this.$moment().toDate(),
      },
    }
  },

  computed: {
    ...mapState(['selectedCompany']),
  },
  watch: {
    filter: {
      handler: 'loadPayoutsRegistries',
      deep: true,
      flush: 'post',
    },
  },
  created() {
    this.startupPage()
  },
  methods: {
    async startupPage() {
      await this.loadPayoutsRegistries()
    },
    async loadPayoutsRegistries() {
      this.isDataLoading = true
      this.payoutsRegistries =
        (
          await CompaniesApi.getPayoutsRegistries(
            this.selectedCompany,
            this.filter
          )
        ).data?.list || []
      this.isDataLoading = false
    },
    uploadPayoutsRegistry() {
      this.$router.push({
        name: 'company-payouts-by-registry-create',
        params: {
          id: this.selectedCompany,
        },
      })
    },
    handleRegistryDeleted(registry) {
      this.$refs.registryDeletedNotification.show()
      this.payoutsRegistries.splice(
        this.payoutsRegistries.findIndex((_r) => _r.id === registry.id),
        1
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.payouts-by-registry {
  &-page {
    .transactions-page-controls {
      margin-top: 30px;
    }

    .payouts-registries-table {
      margin-top: 10px;
    }
  }

  &__date-filter {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
    align-self: flex-end;
    margin-left: 10px;
    margin-right: auto;
  }
}
</style>
